import { useTrack } from "pro-features/components/WithTrack/src/useTrack";
import createSavedSearchTrackingService from "app/pages/sales-intelligence/services/tracking/savedSearchTrackingService";

const useSavedSearchTrackingService = () => {
    const [track] = useTrack();

    return createSavedSearchTrackingService(track);
};

export default useSavedSearchTrackingService;
